import { Email } from '../storage/email'

export function createEmailPDFFileName(email: Email): string {
    // TODO-audit: why is this check needed if all these fields are required?
    if (!email.receivedDate || !email.subject || !email.fromName) {
        return email.externalId.toString() + '.pdf'
    }
    const dateStr = new Date(email.receivedDate).toISOString()
    const truncatedSubject = email.subject.trim().slice(0, 10)
    return `${email.fromName}-${dateStr}-${truncatedSubject}.pdf`
}
